// @flow

import React from 'react';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'components/Col/Col';
import ResultCard from 'components/ResultCard/ResultCard.js';
import ResultCardContainer from 'components/ResultCardContainer/ResultCardContainer.js';
import ResultData from 'components/ResultData/ResultData.js';

import './ParticipantRank.scss';

type Props = {
    rankData: Array,
    dataFont: number
}

const ParticipantRank = ({ rankData, dataFont, shouldDisplayTotal = true }: Props) => {
  return (
    <ResultCardContainer>
      <ResultCard logo="icon-rank">
        <Row gutter={5} fluid className="division-display">
          {rankData.map((rank) => {
            const displayTotal = rank.total ? `/${rank.total}` : '/--';
            const gridNumber = rankData.length && (12 / rankData.length);

            return (
              <Col sm={gridNumber} key={rank.name} span={gridNumber}>
                <ResultData
                  type={rank.name}
                  data={rank.rank}
                  other={shouldDisplayTotal && displayTotal}
                  dataFont={dataFont} />
              </Col>
            );
          })}
        </Row>
      </ResultCard>
    </ResultCardContainer>
  );
};

export default ParticipantRank;